import React, { useEffect } from 'react';
import { Box, Divider, useMediaQuery } from '@mui/material';
import Header from '../components/header';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import useLanguage from '../useLanguage';
import CompanyPhilosophy from '../components/company-philosophy';
import { Eyebrow } from '../components/section';

const CompanyInfoPage = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { language }= useLanguage();

    const formatText = (text: string) => {
        return text.split('\n').map((str, index) => (
            <React.Fragment key={index}>
                {str}
                <br />
            </React.Fragment>
        ));
    };

    useEffect(() => {
        i18n.changeLanguage(language);
    }, []);

    return (
        <div
            style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
            }}
        >
            <Header textColor="#000000" backgroundColor="white"/>
            <Box component="main" sx={{ flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                mt: 12,
                ml: isMobile? 3 : 8,
                pt: '64px'
            }}>
                <h1 style={{ fontSize: isMobile? '2rem' : '4rem', marginBottom: '0.5rem' }}>About Us.</h1>
                {i18n.language === 'ja' && (
                    <h3 style={{ marginTop: '0' }}>会社情報</h3>
                )}
                {isMobile && 
                    <Divider sx={{ mt: 3, mb: 3, mr: 2 }} />
                }
                <CompanyPhilosophy />
                <Box sx={{ mt: { xs: 10, md: 14 } }}>
                    <Eyebrow index="06" label="Overview" />
                    <h2 style={{ fontSize: '1.5rem', marginBottom: 0 }}>{t('corporate.overview')}</h2>
                </Box>
                <Divider sx={{ mt: 3, mb: 3, mr: isMobile? 2 : 20 }} />
                <Box sx={{ mt: isMobile? 0 : 3, display: isMobile? '' : 'flex', alignItems: 'center' }}>
                    <h3 style={{ fontSize: '1rem', width: '13rem', margin: '0.67em 0' }}>{t('Company Label')}</h3>
                    <span style={{ fontSize: '1rem' }}>{t('Company')}</span>
                </Box>
                <Divider sx={{ mt: 3, mb: 3, mr: isMobile? 2 : 20 }} />
                <Box sx={{ mt: isMobile? 0 : 3, display: isMobile? '' : 'flex', alignItems: 'center' }}>
                    <h3 style={{ fontSize: '1rem', width: '13rem', margin: '0.67em 0' }}>{t('Establishment Label')}</h3>
                    <span style={{ fontSize: '1rem' }}>{t('Establishment')}</span>
                </Box>
                <Divider sx={{ mt: 3, mb: 3, mr: isMobile? 2 : 20 }} />
                <Box sx={{ mt: isMobile? 0 : 3, display: isMobile? '' : 'flex', alignItems: 'center' }}>
                    <h3 style={{ fontSize: '1rem', width: '13rem', margin: '0.67em 0' }}>{t('Capital Label')}</h3>
                    <span style={{ fontSize: '1rem' }}>{t('Capital')}</span>
                </Box>
                <Divider sx={{ mt: 3, mb: 3, mr: isMobile? 2 : 20 }} />
                <Box sx={{ mt: isMobile? 0 : 3, display: isMobile? '' : 'flex', alignItems: 'center' }}>
                    <h3 style={{ fontSize: '1rem', width: '13rem', margin: '0.67em 0' }}>{t('Representative Label')}</h3>
                    <span style={{ fontSize: '1rem' }}>{t('Representative1')}</span>
                </Box>
                <Divider sx={{ mt: 3, mb: 3, mr: isMobile? 2 : 20 }} />
                <Box sx={{ mt: isMobile? 0 : 3, display: isMobile? '' : 'flex', alignItems: 'center' }}>
                    <h3 style={{ fontSize: '1rem', width: '13rem', margin: '0.67em 0' }}>{t('Business content Label')}</h3>
                    <span style={{ fontSize: '1rem' }}>{formatText(t('Business content'))}</span>
                </Box>
                {/* <Divider sx={{ mt: 3, mb: 3, mr: isMobile? 2 : 20 }} />
                <Box sx={{ mt: isMobile? 0 : 3, display: isMobile? '' : 'flex', alignItems: 'center' }}>
                    <h3 style={{ fontSize: '1rem', width: '13rem', margin: '0.67em 0' }}>{t('Location Label')}</h3>
                    <span style={{ fontSize: '1rem' }}>{t('Location')}</span>
                </Box> */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 9 }}/>
            </Box>
        </div>

    )
}

export default CompanyInfoPage;